import React, { useState } from 'react';

const languages = [
  'Afrikaans', 'English', 'isiNdebele', 'Sepedi', 'Setswana',
  'Sesotho', 'isiSwati', 'Xitsonga', 'isiXhosa', 'isiZulu',
  '-', '-'
];

export default function LanguageSelector({ onChange }) {
  const [selected, setSelected] = useState(null); // <-- initially nothing selected

  const handleSelect = (lang) => {
    setSelected(lang);
    if (typeof onChange === "function") {
      onChange(lang);
    }
  };

  return (
    <>
      <h3 className="md:text-[36px] text-[10px]  text-black font-bold mb-1   md:mb-4">Language</h3>
      <div className="grid grid-cols-6 md:gap-x-8  md:gap-3  gap-1">
        {languages.map((lang, i) => {
          const isActive = selected === lang;
          return (
            <button
              key={i}
              onClick={() => handleSelect(lang)}
              disabled={lang === '-'}
              className={`
                flex items-center justify-between
                md:w-[185px] md:h-[70px] h-[20px]
                bg-[#E7EBEB]
                border border-[#E7EBEB] rounded-[5px]
                md:px-4 px-2
              
              `}
            >
              <span className="font-medium text-[4px] md:text-[20px] ">{lang}</span>
              <span
                className={`
                  md:w-12 md:h-12 w-3 h-3 rounded-full
                  ${isActive 
                    ? 'bg-[#03897B] md:border-[7px] border-[3px] border-white'
                    : 'md:border-[7px] border-[3px] border-white bg-transparent'}
                `}
              />
            </button>
          );
        })}
      </div>
    </>
  );
}